var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "f7-list",
        { attrs: { "media-list": "" } },
        _vm._l(_vm.filteredAccounts, function (accountItem) {
          return _c(
            "f7-list-item",
            {
              key: accountItem.id,
              attrs: {
                media:
                  "<div class='manualChip'>" +
                  accountItem.name[0].toUpperCase() +
                  "</div>",
                title: accountItem.name,
              },
              on: {
                click: function ($event) {
                  return _vm.switchAccount(accountItem.id)
                },
              },
            },
            [
              _c(
                "f7-swipeout-actions",
                [
                  _c(
                    "f7-swipeout-button",
                    {
                      attrs: {
                        "data-confirm":
                          "You will not be part of this account anymore",
                        "data-confirm-title": "Disengage?",
                        "data-close-on-cancel": "true",
                        delete: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("common.del_label")) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }